(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-product-showcase')) {
    customElements.define('cg-product-showcase', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        this.visible = false;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.controls = this.querySelector('.cg-showcase__controls');
        this.counter = this.querySelector('[data-counter]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.controls.hidden = false;
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); });
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.contains(event.target));
          if (selected >= 0) { this.paused = true; this.updatePause(); this.show(selected, true); }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: .2 });
        this.observer.observe(this);
        this.updatePause();
      }
      updatePause() {
        const label = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
        this.pauseButton.setAttribute('aria-label', label);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) {
          this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
        }
      }
      show(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
          slide.inert = i !== this.index;
          slide.classList.toggle('cg-enter', i === this.index);
        });
        this.counter.setAttribute('aria-live', manual ? 'polite' : 'off');
        this.counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
